import { useQuery } from '@apollo/client';
import { ORGANIZATION_SETTINGS_QUERY } from 'src/modules/entities/organization';

/**
 * The organization's GS1 company prefix for barcodes, read like `useSalesOrderDocumentPrefix`: from the
 * app-wide settings document in the cache only. RoutesBridge's read fills it, so a tag starts no request
 * of its own. Undefined until that read answers, as the org-settings store was.
 */
export function useOrganizationGs1Prefix(): number | null | undefined {
  const { data } = useQuery(ORGANIZATION_SETTINGS_QUERY, { fetchPolicy: 'cache-only' });

  return data?.organization?.gs1CompanyPrefix;
}
